import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IataCuentasDetalleComponent } from "@management/iata-index/iata-cuentas-detalle/iata-cuentas-detalle.component";
import { ClienteService } from "@cliente/cliente.service";
import { ClienteEncabezado } from "@shared/models/cliente/ClienteEncabezado";
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { IATAService } from "@management/iata-index/iata.service";
import { ClienteConfiguracionIATA } from '@shared/models/cliente/clienteIataDTO';
import { MessageService } from '@shell/message.service';
import { TipoCuenta } from '@shared/enums/tipoCuenta';
import { PreciosService } from '@precios/precios.service';
import { Aeroplanta } from '@shared/models/despacho/Aeroplanta';
import { Subject, Subscription } from 'rxjs';
import { ModalConfirmComponent } from "@shared/generic-modals/modal-confirm.component";

@Component({
  selector: 'app-iata-clientes-container',
  templateUrl: './iata-clientes-container.component.html',
  styleUrl: './iata-clientes-container.component.scss'
})

export class IataClientesContainerComponent implements OnInit, OnDestroy {
  cargandoLista: boolean = false;
  clienteSeleccionado: boolean = false;
  clientes: ClienteEncabezado[];
  TipoCuenta = TipoCuenta;

  datosOriginales: ClienteConfiguracionIATA[];
  datosFiltrados: ClienteConfiguracionIATA[];
  datoSeleccionado: ClienteConfiguracionIATA;

  aeroplantasLista: Aeroplanta[];

  readonly entidadesTotales = 3;
  entidadesDescargadas = 0;
  private entidadesDescargadas$ = new Subject<number>();
  subscription: Subscription;

  informacionContainer = new UntypedFormGroup({
    listaCuentasFormControlArray: new UntypedFormArray([])
  });
  constructor(private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private clienteService: ClienteService,
    public activeModal: NgbActiveModal,
    private iataService: IATAService,
    private messageService: MessageService,
    private preciosService: PreciosService) {
      this.subscription = this.entidadesDescargadas$.subscribe( () => {
        this.entidadesDescargadas++;
        if(this.entidadesDescargadas == this.entidadesTotales){
          this.handleSpinner(false);
        }
      });
    }

  ngOnInit() {
    this.handleSpinner(true);
    this.cargarDatosOriginales();
    this.getClientes();
    this.getAeroplantas();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  handleSpinner(load: boolean) {
    this.cargandoLista = load;
    load ? this.spinner.show('spinnerGrafico') : this.spinner.hide('spinnerGrafico');
  }

  cargarDatosOriginales() {
    this.iataService.obtenerClientesSolicitantes()
      .subscribe({
        next: (valor) => {
          const clientesOrdenados = [...valor].sort((a, b) =>
            a.clienteSolicitante.razonSocial.localeCompare(b.clienteSolicitante.razonSocial)
          );
          this.datosOriginales = clientesOrdenados;
          this.datosFiltrados = this.datosOriginales;
          this.iataService.setConfiguraciones(this.datosOriginales);
          },
        error: (error) => {
          this.messageService.showErrorMessage(error.description);
          this.entidadesDescargadas$.next();
        },
        complete: () => {
          this.entidadesDescargadas$.next()
        }
      });
  }

  usuarioSeleccionaDato(data: ClienteConfiguracionIATA) {
    this.datoSeleccionado = data;
    this.clienteSeleccionado = true;
    this.actualizarFormArray();
  
    if (data.configuracion) {
      this.iataService.setConfiguracion(data);
    } else {
      this.iataService.limpiarConfiguracion();
    }
  }

  nuevaConfiguracion() {
    const modalRef = this.modalService.open(IataCuentasDetalleComponent, { centered: true, backdrop: 'static' });
    modalRef.componentInstance.clienteNuevo = true;
    modalRef.componentInstance.clienteIataArray = this.datosOriginales;
    modalRef.result.then((clienteIata) => {
      this.datosOriginales = [...this.datosOriginales, clienteIata];
      this.datosFiltrados = [...this.datosFiltrados, clienteIata];
    })
  }

  filtrarDatos(valor: string) {
    const filtro = valor.toLowerCase().trim();
    this.datosFiltrados = this.datosOriginales.filter(item => item.clienteSolicitante.razonSocial.toLowerCase().includes(filtro))
  }

  getClientes(): void {
    this.clienteService.getClientesEncabezado()
      .subscribe(clientes => {
        this.clientes = clientes;
        this.iataService.clientes.set(this.clientes);
        this.entidadesDescargadas$.next();
      }, () => {
        this.messageService.showErrorMessage('Error al obtener clientes.');
        this.entidadesDescargadas$.next();
      });
  }

  getAeroplantas() {
    this.preciosService.obtenerTodasLasAeroplantas()
      .subscribe(result => {
        this.aeroplantasLista = result.sort((a, b) => { if (a.nombre > b.nombre) { return 1 } else { return -1 } }).filter(aero => !['TDL','DTO','JNI','ENO','CUT'].includes(aero.codigoAeroplanta));
        this.entidadesDescargadas$.next();
      }, () => {
        this.messageService.showErrorMessage('Error al obtener aeroplantas.');
        this.entidadesDescargadas$.next();
      });
  }

  agregarCuenta() {
    const modalRef = this.modalService.open(IataCuentasDetalleComponent, { 
      centered: true, 
      size: 'lg', 
      backdrop: 'static' 
    });
    modalRef.componentInstance.agregarCuenta = true;
    modalRef.componentInstance.aeroplantasLista = this.aeroplantasLista;
    modalRef.result.then((nuevaConfiguracion: ClienteConfiguracionIATA) => {
      if (nuevaConfiguracion) {
        const clienteIndex = this.datosOriginales.findIndex(c =>
          c.clienteSolicitante.razonSocial === nuevaConfiguracion.clienteSolicitante.razonSocial
        );
        if (clienteIndex !== -1) {
          this.datosOriginales[clienteIndex] = nuevaConfiguracion;
        } else {
          this.datosOriginales.push(nuevaConfiguracion);
        }
    
        if (
          this.datoSeleccionado &&
          this.datoSeleccionado.clienteSolicitante.razonSocial === nuevaConfiguracion.clienteSolicitante.razonSocial
        ) {
          this.datoSeleccionado = nuevaConfiguracion;
          this.actualizarFormArray();
        }
      }
    });
  }

  eliminarCuenta(index: number) {
    const modalRef = this.modalService.open(ModalConfirmComponent, {
      centered: true,
      backdrop: "static",
    });
    modalRef.componentInstance.mensaje = "¿Desea eliminar la cuenta?";
    modalRef.result
      .then(() => {
        this.handleSpinner(true);
        this.datoSeleccionado.configuracion.splice(index, 1);
        this.actualizarFormArray();
    
        this.iataService.putCuentasConfiguracionIATA(this.datoSeleccionado)
          .subscribe(() => {
            this.handleSpinner(false);
            this.messageService.showSuccessMessage('Cuenta eliminada correctamente.');
          }, () => {
            this.handleSpinner(false);
            this.messageService.showErrorMessage('Ha habido un error al eliminar la cuenta.');
          });
      })
      .catch(() => { return });
  }
  actualizarFormArray() {
    this.listaCuentasFormControlArray.clear();
    if (this.datoSeleccionado && this.datoSeleccionado.configuracion) {
      this.datoSeleccionado.configuracion.forEach(config => {
        const grupo = new UntypedFormGroup({
          cuentaSolicitante: new UntypedFormControl(config.cuentaSolicitante),
          clienteImputar: new UntypedFormControl(config.clienteImputar),
          cuentaImputar: new UntypedFormControl(config.cuentaImputar),
          aeroplantas: new UntypedFormControl(config.aeroplantas)
        });
        this.listaCuentasFormControlArray.push(grupo);
      });
    }
  }
  
  

  get listaCuentasFormControlArray(): UntypedFormArray {
    return this.informacionContainer.controls.listaCuentasFormControlArray as UntypedFormArray;
  }
}
